
import RoundButton from "@/components/buttons/RoundButton.vue";
import colors from "@/styles/colors";

export default {
    name: "ClearRecordButton",
    components: {
        RoundButton
    },
    data() {
        return {
            colors
        };
    }
};
